import { AxiosResponse } from 'axios';
import { MainMenuEditResponse, MainMenuResponse } from 'types/entity';
import { http } from './settings';

export const fatchMainMenu = (projectId: string, mainMenuId: string): Promise<Required<MainMenuResponse>> => http
  .get(`/projects/${projectId}/main-menus/${mainMenuId}`)
  .then((value: AxiosResponse<Required<MainMenuResponse>>) => value.data);

export const fetchAdminMainMenu = (projectId: string, mainMenuId: string): Promise<Required<MainMenuEditResponse>> => http
  .get(`/admin/projects/${projectId}/main-menus/${mainMenuId}`)
  .then((value: AxiosResponse<Required<MainMenuEditResponse>>) => value.data);
